import styled from 'styled-components';

const Dot = styled.span<{ $color: string; $opacity?: number }>`
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: ${(props) => props.$color};
	opacity: ${(props) => (props.$opacity ? props.$opacity : 1)};
`;

export { Dot };
